import {
  CREATE_COLLECTION_ITEM,
  CREATE_COLLECTION_ITEM_SUCCESS,
  CREATE_COLLECTION_ITEM_ERROR,
  UPDATE_COLLECTION_ITEM_STATE,
} from "../actions";

const INIT_STATE = {
  isCollectionItemRecordPanelShown: false,
  loading: false,
  collectionItemCreateError: null,
  collectionItemSaved: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_COLLECTION_ITEM:
      return { ...state, loading: true, collectionItemCreateError: null, record: action.payload.newRecord };
    case CREATE_COLLECTION_ITEM_SUCCESS:
      return { ...state, loading: false, collectionItemCreateError: null, collectionItemSaved: action.payload, isNewRecordPanelShown: false };
    case CREATE_COLLECTION_ITEM_ERROR:
      return { ...state, loading: false, collectionItemCreateError: action.payload.message };
    case UPDATE_COLLECTION_ITEM_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};
